export default __webpack_public_path__ + "static/media/chandosBook.cac4a735.jpg";